import { FacilityBrand } from '@/types/generated';

export function formatPhoneNumber(phoneNumberString: string, brand: FacilityBrand) {
	const cleanedPhoneNumber = ('' + phoneNumberString).replace(/\D/g, '');

	if (brand === FacilityBrand.AspenDental) {
		const matchPhoneNumberFormat = cleanedPhoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
		if (matchPhoneNumberFormat) {
			return '(' + matchPhoneNumberFormat[1] + ') ' + matchPhoneNumberFormat[2] + '-' + matchPhoneNumberFormat[3];
		}
		return null;
	}

	const matchPhoneNumberFormat = cleanedPhoneNumber.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
	if (matchPhoneNumberFormat) {
		return '(' + matchPhoneNumberFormat[2] + ') ' + matchPhoneNumberFormat[3] + '-' + matchPhoneNumberFormat[4];
	}
	return null;
}
